import { useCallback } from 'react'

import { useFormField } from 'cng-common/features/form'
import { GeoMapping } from 'partner360/components/filters'

import { IFormGeoSelectorProps } from './models'

export const FormGeoSelector = ({
  defaultValue = [],
  formKey,
  field,
  label,
  onChange,
  typeOfSelectedNodes,
  allowedCountryCodes,
}: IFormGeoSelectorProps) => {
  const { value, handleChange } = useFormField({
    defaultValue,
    formKey,
    field,
    onChange,
  })

  const onChangeGeoMapping = useCallback(
    (displayedIds: string[], allSelectedIds: string[], onlyLeavesIds: string[]) => {
      handleChange(onlyLeavesIds)
    },
    [handleChange]
  )

  return (
    <GeoMapping
      values={value}
      label={label}
      onSelectChange={onChangeGeoMapping}
      typeOfSelectedNodes={typeOfSelectedNodes}
      allowedCountryCodes={allowedCountryCodes}
    />
  )
}
